export default "__VITE_ASSET__gys3w3mo__"